class FaqAccordion {
	constructor(selector = "[data-faqs-accordion]") {
		this.accordions = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.accordions.length) {
			return
		}

		this.accordions.forEach(accordion => {
			accordion.addEventListener("click", event => this.handleClick(event))
		})
	}

	handleClick(event) {
		const button = event.target.closest(".faqs-accordion__button")

		if (!button) {
			return
		}

		const item = button.closest(".faqs-accordion__item")
		const panelId = button.getAttribute("aria-controls")
		const panel = panelId ? document.getElementById(panelId) : null
		const isOpen = button.getAttribute("aria-expanded") === "true"

		if (!item || !panel) {
			return
		}

		this.setItemState(item, button, panel, !isOpen)
	}

	setItemState(item, button, panel, isOpen) {
		item.classList.toggle("is-active", isOpen)
		button.setAttribute("aria-expanded", String(isOpen))
		panel.hidden = !isOpen
	}
}

export default FaqAccordion
